import { useEffect, useState } from "react";
import {
  ListRemediationRequestsQuery,
  useListRemediationRequestsQuery,
} from "../generated";
import RemediationRequest from "../models/RemediationaRequest";

const useRemediationApprovals = ({ arn }: any) => {
  const [loading, setLoading] = useState(true);
  const [nextPage, setNextPage] = useState(1);
  const [data, setData] = useState<any>([]);

  const {
    loading: dataLoading,
    data: approvalData,
    error,
    refetch,
    fetchMore,
  } = useListRemediationRequestsQuery({
    variables: {
      arn: arn,
      page: nextPage,
      limit: 100,
    },
    context: {
      apiName: "automation_approval",
    },
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!dataLoading && nextPage > 1) {
      fetchMore({
        variables: {
          arn: arn,
          page: nextPage,
          limit: 100,
        },
        context: {
          apiName: "automation_approval",
        },
      }).then((res) => {
        if (res.data) {
          processResponse(res.data);
        }
      });
    }
  }, [nextPage]);

  useEffect(() => {
    if (!dataLoading && approvalData) {
      processResponse(approvalData);
    }
  }, [approvalData, dataLoading]);

  const refresh = () => {
    setLoading(true);
    setData([]);
    setNextPage(1);
    refetch();
  };

  const processResponse = (approvalData: ListRemediationRequestsQuery) => {
    const resultsJsonString = approvalData?.listRemediationRequests?.results;
    if (resultsJsonString === "[]" || !resultsJsonString) {
      setLoading(false);
      return;
    }
    const resultsJson = JSON.parse(resultsJsonString);
    const resultNextPage = approvalData?.listRemediationRequests?.page;
    let newData = [];
    if (nextPage > 1) {
      newData = [...data, ...resultsJson];
    } else {
      newData = resultsJson;
    }
    newData.sort((a: RemediationRequest, b: RemediationRequest) => {
      return (
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
    });
    if (resultNextPage) {
      setNextPage(resultNextPage);
    } else {
      setLoading(false);
    }
    setData(newData);
  };

  return {
    loading,
    data,
    refresh,
  };
};

export default useRemediationApprovals;
